import { createFileRoute } from "@tanstack/react-router";
import LearnHubEs, { esHubSchema } from "@/pages/learn/es/LearnHubEs";
import { SITE_URL, buildHreflang } from "@/lib/i18n/locale";

const ES_URL = `${SITE_URL}/es/learn`;

export const Route = createFileRoute("/es/learn/")({
  head: () => ({
    meta: [
      { title: "Educación para pacientes | Neuro Wellness TMS" },
      {
        name: "description",
        content:
          "Guías en lenguaje claro sobre TMS, SAINT® TMS, TMS acelerada, Spravato®, depresión resistente al tratamiento y cómo se comparan los tratamientos para la.",
      },
      {
        property: "og:title",
        content: "Educación para pacientes | Neuro Wellness TMS",
      },
      {
        property: "og:description",
        content:
          "Guías en lenguaje claro sobre TMS, SAINT® TMS, TMS acelerada, Spravato®, depresión resistente al tratamiento y cómo se comparan los tratamientos para la.",
      },
      { property: "og:url", content: ES_URL },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "es_ES" },
      { name: "twitter:card", content: "summary_large_image" },
      {
        name: "twitter:title",
        content: "Educación para pacientes | Neuro Wellness TMS",
      },
      {
        name: "twitter:description",
        content:
          "Guías en lenguaje claro sobre TMS, SAINT® TMS, TMS acelerada, Spravato®, depresión resistente al tratamiento y cómo se comparan los tratamientos para la depresión. Revisado médicamente.",
      },
    ],
    links: [{ rel: "canonical", href: ES_URL }, ...buildHreflang("/learn")],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(esHubSchema),
      },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <LearnHubEs />;
}
